import {colorGroup, colorLabel, sortColors} from './evolved-device-color-order.js?v=20260925-1';
/* Exact Watch variants stay server-rendered; filtering preserves their image, price and URL. */
if (!customElements.get('evolved-watch-bands')) {
  customElements.define('evolved-watch-bands', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const {signal} = this.controller;
      const init = () => {
        if (!this.isConnected) return;
        this.select = this.querySelector('[data-watch-model]');
        this.colorSelect = this.querySelector('[data-watch-color]');
        this.panels = [...this.querySelectorAll('[data-watch-color-panel]')];
        if (!this.select || !this.panels.length) return;
        this.panelCards = new Map(this.panels.map(panel=>[panel,[...panel.querySelectorAll('.ev-watch-color-card')]]));
        const readHash = () => {
          const params = new URLSearchParams(location.hash.slice(1)), size = params.get('watch-size');
          const option = [...this.select.options].find(item=>item.dataset.size===size);
          if (option) this.select.value = option.value;
          this.pendingColor = colorGroup(params.get('watch-color')).key; this.update(false);
        };
        this.select.addEventListener('change',()=>this.update(true),{signal});
        this.colorSelect?.addEventListener('change',()=>this.update(true),{signal});
        window.addEventListener('hashchange',readHash,{signal}); readHash();
      };
      if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true,signal});
      else init();
    }
    update(changed) {
      const option = this.select.selectedOptions[0]; if (!option) return;
      this.panels.forEach(panel=>{panel.hidden=panel.dataset.watchColorPanel!==option.value;});
      const active = this.panels.find(panel=>!panel.hidden); if (!active) return;
      const cards = this.panelCards.get(active) || [], colors = new Map();
      for (const card of cards) {
        const name = card.dataset.guideColor, group = colorGroup(name), key = group.key; if (!name) continue;
        const previous = colors.get(key);
        if (previous) { previous.count++; previous.names.push(name); } else colors.set(key,{...group,names:[name],count:1});
      }
      const ordered = sortColors([...colors.values()],option.textContent);
      const wanted = this.pendingColor ?? this.colorSelect?.value ?? ''; this.pendingColor = null;
      if (this.colorSelect) {
        this.colorSelect.replaceChildren(new Option('All colors',''),...ordered.map(color=>new Option(colorLabel(color),color.key)));
        this.colorSelect.disabled=!ordered.length;
        this.colorSelect.value=colors.has(wanted)?wanted:'';
      }
      const selected = this.colorSelect?.value || '', ranking = new Map(ordered.map((color,index)=>[color.key,index]));
      const visible = cards.filter(card=>!selected||colorGroup(card.dataset.guideColor).key===selected)
        .sort((a,b)=>(ranking.get(colorGroup(a.dataset.guideColor).key)??999)-(ranking.get(colorGroup(b.dataset.guideColor).key)??999));
      active.querySelector('.ev-guide__grid').replaceChildren(...visible);
      active.querySelector('.ev-watch-color-count').textContent = selected ? visible.length+' matching '+(visible.length===1?'option':'options') : visible.length+' colors & finishes';
      const destination = new URL(this.dataset.bandsUrl,location.href);
      const hash = new URLSearchParams({'watch-size':option.dataset.size});
      if (selected) hash.set('watch-color',selected);
      destination.hash=hash.toString();
      this.closest('.ev-watch-guide')?.querySelectorAll('[data-watch-all]').forEach(link=>{link.href=destination.pathname+destination.search+destination.hash;});
      active.querySelectorAll('[data-rail-mobile-all]').forEach(link=>{
        link.href=destination.pathname+destination.search+destination.hash;
        link.textContent='View all '+visible.length+' '+(visible.length===1?'option':'options')+' →';
      });
      active.querySelectorAll('evolved-product-rail').forEach(rail=>{if(changed)rail.scrollTo({left:0,behavior:'auto'});});
      active.querySelectorAll('evolved-rail-controls').forEach(controls=>controls.scheduleUpdate?.());
      const status = this.querySelector('[data-watch-status]');
      if (status) status.textContent=visible.length+' '+(visible.length===1?'option':'options')+' for '+option.textContent.trim();
      if (changed && this.dataset.fullCollection==='true') {
        const url=new URL(location.href);url.hash=destination.hash;history.replaceState(history.state,'',url);
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
